import React from 'react';
import { BarChart, Bar, YAxis, CartesianGrid, Tooltip, XAxis } from 'recharts';
import { formatLargeNumber } from '../../../../utility/formatNumbers';
import { valueFormatter } from '../../../../views/SummaryPage/Comparison/ScenarioGraph/helperFunctions';

export default function BarGraph({ chartSchema, data, title, unit = '$' }) {
  const chartData = [];

  chartSchema?.map((field) => {
    const { name, label, multiplier } = field;
    chartData.push({
      name: label,
      value: multiplier ? data[name] * multiplier : data[name],
    });
  });

  const renderToolTip = function (entry) {
    const { payload } = entry;
    if (payload && payload.length) {
      const { name, value } = payload[0].payload;
      return (
        <div className="bg-white p-3 shadow-md rounded-md focus:outline-none">
          <div className="text-base text-neutral-500">{name}</div>
          <div className="text-base text-neutral-700">
            {unit === '$'
              ? `${unit}${formatLargeNumber(value)}`
              : `${value}${unit}`}
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <h2 className="text-center text-lg font-medium text-black pb-2">
        {title}
      </h2>
      <div className="-ml-4 mb-4">
        <BarChart
          width={350}
          height={300}
          data={chartData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <YAxis
            tickFormatter={(tick) => valueFormatter(tick, unit)}
            type="number"
            style={{ fontSize: '12px' }}
          />
          <XAxis dataKey="name" style={{ fontSize: '12px' }} />
          <Tooltip content={renderToolTip} />

          {/* <Legend /> */}

          <Bar dataKey={'value'} stackId="a" fill={'#1378F7'} />
        </BarChart>
      </div>
    </div>
  );
}
